import { LOCATION_CHANGE } from "redux-first-history"

export const CALL_HISTORY_METHOD = "@@router/CALL_HISTORY_METHOD"

// https://github.com/salvoravida/redux-first-history/blob/master/src/reducer.ts
export const createRouterReducer = ({ basename }) => {
  const initialState = {
    action: null,
    basename,
    location: null,
  }

  return (state = initialState, { type, payload }) => {
    if (type === LOCATION_CHANGE) {
      let { location, action } = payload || {}

      // This ensures pathname store in the router state is not prepended with the basename
      if (
        basename &&
        location &&
        location.pathname &&
        location.pathname.startsWith(basename)
      ) {
        location = {
          ...location,
          pathname: location.pathname.slice(basename.length) || "/",
        }
      }

      return {
        ...state,
        action,
        location,
      }
    }

    return state
  }
}

// https://github.com/salvoravida/redux-first-history/blob/master/src/middleware.ts
function appendBasename(location, basename) {
  // redux-first-history's original appendBasename fails when location is `/cart` and basename is `/ca`
  if (typeof location === "string" && !location.startsWith(`${basename}/`)) {
    return basename + location
  }
  if (
    typeof location === "object" &&
    !!location.pathname &&
    !location.pathname.startsWith(`${basename}/`)
  ) {
    return { ...location, pathname: basename + location.pathname }
  }
  return location
}

export const createRouterMiddleware =
  ({ history, showHistoryAction, basename }) =>
  () =>
  // @ts-ignore
  (next) =>
  (action) => {
    if (action.type !== CALL_HISTORY_METHOD) {
      return next(action)
    }
    // @ts-ignore
    const method = action.payload.method
    // @ts-ignore
    const args = action.payload.args

    // eslint-disable-next-line default-case
    switch (method) {
      case "push": {
        let callArgs = args
        if (basename && args.length > 0) {
          callArgs = [appendBasename(args[0], basename), ...args.slice(1)]
        }
        history.push(...callArgs)
        break
      }
      case "replace": {
        let callArgs = args
        if (basename && args.length > 0) {
          callArgs = [appendBasename(args[0], basename), ...args.slice(1)]
        }
        history.replace(...callArgs)
        break
      }
      case "go":
        history.go(...args)
        break
      case "back":
      case "goBack":
        // @ts-ignore
        history.goBack && history.goBack(...args)
        //@ts-ignore //support history 5.x
        history.back && history.back(...args)
        break
      case "forward":
      case "goForward":
        // @ts-ignore
        history.goForward && history.goForward(...args)
        //@ts-ignore //support history 5.x
        history.forward && history.forward(...args)
        break
    }
    if (showHistoryAction) return next(action)
  }
